(function () {
	document.addEventListener("DOMContentLoaded", (event) => {
		const saleLockdown = sessionStorage.getItem('sale-lockdown');

		if (!!saleLockdown === true) {
			window.location.href = '/pages/sale-lockdown'
		}
	});
})();